/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Carry_Why_LighterInputs */

const en_us2_workout_after_carry_why_lighter = /** @type {(inputs: Workout_After_Carry_Why_LighterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The last two times you lifted less than the plan.`)
};

const pt_br2_workout_after_carry_why_lighter = /** @type {(inputs: Workout_After_Carry_Why_LighterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nas duas últimas vezes você usou menos carga que o plano.`)
};

const es_419_workout_after_carry_why_lighter = /** @type {(inputs: Workout_After_Carry_Why_LighterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las dos últimas veces levantaste menos que el plan.`)
};

const pt_pt2_workout_after_carry_why_lighter = /** @type {(inputs: Workout_After_Carry_Why_LighterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nas duas últimas vezes usaste menos carga do que o plano.`)
};

const fr_fr2_workout_after_carry_why_lighter = /** @type {(inputs: Workout_After_Carry_Why_LighterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les deux dernières fois, tu as soulevé moins que le programme.`)
};

const de_de2_workout_after_carry_why_lighter = /** @type {(inputs: Workout_After_Carry_Why_LighterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die letzten zwei Male hast du weniger bewegt als im Plan.`)
};

const it_it2_workout_after_carry_why_lighter = /** @type {(inputs: Workout_After_Carry_Why_LighterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le ultime due volte hai sollevato meno di quanto previsto dalla scheda.`)
};

/**
* | output |
* | --- |
* | "The last two times you lifted less than the plan." |
*
* @param {Workout_After_Carry_Why_LighterInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_carry_why_lighter = /** @type {((inputs?: Workout_After_Carry_Why_LighterInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Carry_Why_LighterInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_carry_why_lighter(inputs)
	if (locale === "es-419") return es_419_workout_after_carry_why_lighter(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_carry_why_lighter(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_carry_why_lighter(inputs)
	if (locale === "de-DE") return de_de2_workout_after_carry_why_lighter(inputs)
	if (locale === "it-IT") return it_it2_workout_after_carry_why_lighter(inputs)
	return en_us2_workout_after_carry_why_lighter(inputs)
});
export { workout_after_carry_why_lighter as "workout-after.carry_why_lighter" }